import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { Subject } from 'rxjs';
import {  takeUntil } from 'rxjs/operators';
import { HelpPlanService } from '../help-plan.service';
import { TemplateModel } from '../Models/template.model';
import { TemplateDetailsComponent } from '../template-details/template-details.component';
import { TemplateService } from '../template-service';
import { saveAs } from '@progress/kendo-file-saver';
import { CedNotificationService } from 'ced-ng-library';

@Component({
  selector: 'app-template-list',
  templateUrl: './template-list.component.html',
  styleUrls: ['./template-list.component.scss']
})
export class TemplateListComponent implements OnInit, OnDestroy  {
  private _subject$: Subject<boolean> = new Subject();
  templates: any = [];
  public documentModel = new TemplateModel();
  public active = false;
  public selectedTemplate: TemplateModel = null;
  index : number;
  private helpPlanList = [];
  public isloading: boolean = false;

  selectedFiles: File[] = [];
  acceptedFileTypes = '.docx'; 
  base64: string;

  constructor(private dialogService: DialogService,
    private templateService: TemplateService,
    private helpPlanService: HelpPlanService,
    private cedNotificationService: CedNotificationService) { }

    ngOnInit() {
      this.getTemplates();   
      this.getHelpPlans();   
    } 

 
  public removeIconHandler(e): void
  {
   this.active = false;
   }

   openDetails() {
    if (this.selectedTemplate != null)
      this.openDialog();
    this.selectedTemplate = null;
  }

  onCellClick($event) {
    this.selectedTemplate = $event.dataItem
    this.index = $event.rowIndex;
  }

  openDialog() {
    const dialogRef = this.dialogService.open({
      content: TemplateDetailsComponent,
      width:"700px"
    });
    dialogRef.content.instance.selectedTemplate = this.selectedTemplate;   
    dialogRef.content.instance.helpPlanValues = this.helpPlanList;
    dialogRef.result.subscribe((result: any) => { 
      if (!(result instanceof DialogCloseResult)) {
        if(result.tlId == null){
            this.templateService.save(result)
            .pipe(takeUntil(this._subject$))
            .subscribe((data) => {
              if(data){
                this.getTemplates();
                this.selectedTemplate = null;
              }else{
                  this.cedNotificationService.error("TEMPLATES.TEMPLATE_NAME_EXISTS");
              }
          }); 
        }
        else{
          this.templateService.update(result)
            .pipe(takeUntil(this._subject$))
            .subscribe((data: any) => {
              if(data){
                this.getTemplates();
                this.selectedTemplate = null;
              }else{
                  this.cedNotificationService.error("TEMPLATES.TEMPLATE_NAME_EXISTS");
              }
          }); 
        }         
      }
      this.selectedTemplate = null;
    });
  }

  getTemplates() {
    this.isloading = true;
    this.templateService
    .getAll()
    .pipe(takeUntil(this._subject$))
    .subscribe((data: any) => {
      this.templates = data;        
      this.isloading = false;
    });
  }

  getHelpPlans(){
    this.helpPlanService.getAll()
    .pipe(takeUntil(this._subject$))
    .subscribe((data: any) => {
      this.helpPlanList = data;
    });
  }

  getHelpPLanCodes(template){
    let codes = template.templateHelpPlans.map(x=>x.thpHelpPlan.hplCode.trim());
      return codes;
  }

  previewTemplate(dataItem){
    this.templateService
      .previewTemplate(dataItem,)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        const byteArray = new Uint8Array(atob(data.content).split('').map(char => char.charCodeAt(0)));
        let blob =  new Blob([byteArray], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      });
  }
  
  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }

  onFileSelected(event: Event): void {
  const input = event.target as HTMLInputElement;

  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    const reader = new FileReader();
    const fileNameWithoutExtension = file.name.replace(/\.docx$/i, '');
    reader.onload = () => {
      const result = reader.result as string;
      this.base64 = result.split(',')[1]; 
      this.templateService.setbase64DocxTemplate(fileNameWithoutExtension, this.base64)
        .pipe(takeUntil(this._subject$)).subscribe(() => 
          {
           this.cedNotificationService.success("TEMPLATES.TEMPLATE_UPLOADED");
          },
         () => {
               this.cedNotificationService.error("TEMPLATES.TEMPLATE_UPLOAD_FAILED"); 
          });
    };

    reader.readAsDataURL(file);
  }
}
  
downloadTemplate(templateName: string): void {
  this.templateService.getbase64DocxTemplate(templateName)
    .pipe(takeUntil(this._subject$))
    .subscribe(
      (data: any) => {
        const base64String = data.base64Docx; 
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });

        saveAs(blob, `${templateName}.docx`);
        this.cedNotificationService.success("TEMPLATES.TEMPLATE_DOWNLOADED");
      },
      () => {
        this.cedNotificationService.error("TEMPLATES.TEMPLATE_DOWNLOAD_FAILED");
      }
    );
}
  ngOnDestroy(): void {
    this._subject$.next();
    this._subject$.complete(); 
  }
}
